import BasePackageDetailsTable from './PackageDetailsTable';

// EXPORT
export const PackageDetailsTable = BasePackageDetailsTable;
export type { PackageDetailsTableProps, ItemDetails } from './PackageDetailsTable.interface';
